import { render, staticRenderFns } from "./ResourceManage.vue?vue&type=template&id=4c0df818&scoped=true"
import script from "./ResourceManage.vue?vue&type=script&lang=js"
export * from "./ResourceManage.vue?vue&type=script&lang=js"
import style0 from "./ResourceManage.vue?vue&type=style&index=0&id=4c0df818&prod&scoped=true&lang=css"
import style1 from "./ResourceManage.vue?vue&type=style&index=1&id=4c0df818&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0df818",
  null
  
)

export default component.exports